import Dictionary from '../data/dictionary'

const getText = (lang: string, key: string) => {
  return Dictionary[lang][key] || `undefined word ${key}`
}

const getDefaultLanguage = () => {
  const language = (window.navigator.languages && window.navigator.languages[0]) ||
  window.navigator.language

  if (!language) {
    console.warn('Can\'t get languages:', language)
    return 'ja'
  }

  const lang = language.substring(0, 2)
  if (!Dictionary[lang]) {
    console.warn('Unsupported language:', lang)
    return 'ja'
  }

  return lang
}

const getSupportedLanguages = () => {
  return Object.keys(Dictionary)
}

export { Dictionary, getText, getDefaultLanguage, getSupportedLanguages }
